import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Menu, Layout,
  Drawer,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHouse, faIndustry, faChartPie, faGear, faTags, faBagShopping, faCartShopping, faFileShield, faBolt, faMessage, faThumbsUp, faCircleQuestion, faFileUpload, faBell, faSackDollar,
  faWarehouse,
  faCircleXmark,
  faUserTie, 
} from '@fortawesome/free-solid-svg-icons';
import Crown from '@Images/crown2.png';
import H3Image from '@Uilib/h3Image';
import TenantActions from '@Actions/tenantActions';
import Helpers from '@Apis/helpers';
import logo from '../../../media/images/logo-without-tagline.png';
import H3Text from '@Uilib/h3Text';
import documentUINamesConstant from '../../../apis/documentUINamesConstant';
import { AppstoreOutlined, HomeOutlined, LoadingOutlined, MailOutlined, SettingOutlined, ShoppingCartOutlined, UserOutlined } from '@ant-design/icons';
import React, { useEffect, useState, useMemo, Fragment } from "react";
import SubMenu from 'antd/es/menu/SubMenu';
import { useLocation } from "react-router-dom";
import Sider from 'antd/es/layout/Sider';
import WhatsApp from '../../../media/images/whatsapp.png';


const UserMenuHover = ({history, user, getTenants, getTenantsConfiguration, org}) => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState('/');
  const [collapse, setCollapse] = useState(false); 
  const [openKeys, setOpenKeys] = useState([]);
  const [documentUINames, setDocumentUINames] = useState({});
  const [showDrawer, setShowDrawer] = useState(false);
  const [iframeUrl, setIframeUrl] = useState('');
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const handleMouseEnter = () => {
    setCollapsed(false); // Expand the menu on mouse enter
  };
  const handleMouseLeave = () => {
    setCollapsed(true); // Collapse the menu on mouse leave
  };

  useEffect(() => {
    if (user?.role_id === 10001) {
      getTenants(currentPage, "", true, user?.tenant_info?.org_id);
    }
    setCurrentPage(location.pathname);

    const menuKeys = [
      { path: "/inventory", key: "/inventory" },
      { path: "/logistic", key: "/logistic" },
      { path: "/production", key: "/production" },
      { path: "/quality", key: "/quality" },
      { path: "/settings", key: "/settings" },
      { path: "/purchase", key: "/purchase" },
      { path: "/approval", key: "/purchase" },
      { path: "/payments", key: "/payments" },
      { path: "/analytics", key: "/analytics" },
      { path: "/sales", key: "/sales" },
    ];

    const matchedKeys = menuKeys
      .filter(({ path }) => location.pathname.includes(path))
      .map(({ key }) => key);

    setOpenKeys(matchedKeys);
  }, [location.pathname, user, getTenants]);

  // Fetch tenant configuration when user data is available
  useEffect(() => {
    if (user) {
      getTenantsConfiguration(user?.tenant_info?.tenant_id);
      setDocumentUINames(documentUINamesConstant(user));
    }
  }, [user, getTenantsConfiguration]);

  const handleMenuClick = (url, type) => {
    setShowDrawer(true);
    setIframeUrl(url);
    setIframeLoaded(false);
  };
  const handleMenuClickClose = () => {
    setOpenKeys([]);
  };

  const hasSpecificPermission = (entity, type, user) => {
    return Helpers.getPermission(entity, type, user);
  };

  const hasProductPermissions = (user) => {
    return (
      hasSpecificPermission(Helpers.permissionEntities.PRODUCT, Helpers.permissionTypes.READ, user) ||
      hasSpecificPermission(Helpers.permissionEntities.PRODUCT_CATEGORY, Helpers.permissionTypes.READ, user) ||
      hasSpecificPermission(Helpers.permissionEntities.INVENTORY, Helpers.permissionTypes.READ, user) ||
      hasSpecificPermission(Helpers.permissionEntities.WAREHOUSE, Helpers.permissionTypes.READ, user)
    );
  };

  const hasLogisticsPermissions = (user) => {
    return (
      hasSpecificPermission(Helpers.permissionEntities.GATE_DOCUMENT, Helpers.permissionTypes.READ, user)
    )
  };
  
  const hasPurchasePermissions = (user) => {
    return (
      hasSpecificPermission(Helpers.permissionEntities.VENDORS, Helpers.permissionTypes.READ, user) || 
      hasSpecificPermission(Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ, user) || 
      hasSpecificPermission(Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ, user) || 
      hasSpecificPermission(Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.READ, user)
    )
  };

  const hasProductionPermissions = (user) => {
    return (
      hasSpecificPermission(Helpers.permissionEntities.MO, Helpers.permissionTypes.READ, user) ||
      hasSpecificPermission(Helpers.permissionEntities.BOM, Helpers.permissionTypes.READ, user) ||
      hasSpecificPermission(Helpers.permissionEntities.FACTORY_SETUP, Helpers.permissionTypes.READ, user) ||
      hasSpecificPermission(Helpers.permissionEntities.MRP, Helpers.permissionTypes.READ, user)
    );
  };

  const hasQualityPermissions = (user) => {
    return (
      Helpers.getPermission(Helpers.permissionEntities.QUALITY_RULES, Helpers.permissionTypes.READ, user) ||
      Helpers.getPermission(Helpers.permissionEntities.QUALITY_CHECKS, Helpers.permissionTypes.READ, user)
    );
  };

  const hasSalesPermissions = (user) => {
    return (
      hasSpecificPermission(Helpers.permissionEntities.CUSTOMER, Helpers.permissionTypes.READ, user) ||
      hasSpecificPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ, user) ||
      hasSpecificPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ, user) ||
      hasSpecificPermission(Helpers.permissionEntities.CREDIT_NOTE, Helpers.permissionTypes.READ, user)
    );
  };

  const hasAccountingPermissions = (user) => {
    return (
      Helpers.getPermission(Helpers.permissionEntities.REPORTS, Helpers.permissionTypes.READ, user) ||
      Helpers.getPermission(Helpers.permissionEntities.VENDOR_PAYOUT, Helpers.permissionTypes.READ, user) ||
      Helpers.getPermission(Helpers.permissionEntities.CUSTOMER_PAYMENTS, Helpers.permissionTypes.READ, user)
    );
  };

  const hasAnalyticsPermissions = (user) => {
    return (
      Helpers.getPermission(Helpers.permissionEntities.REPORTS, Helpers.permissionTypes.READ, user) ||
      true // Bulk Upload appears to be always available
    );
  };

  const hasSettingsPermissions = (user) => {
    return (
      Helpers.getPermission(Helpers.permissionEntities.USER_MANAGEMENT, Helpers.permissionTypes.READ, user) ||
      Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP, Helpers.permissionTypes.READ, user) ||
      Helpers.getPermission(Helpers.permissionEntities.WORKFLOW_SETUP, Helpers.permissionTypes.READ, user)
    );
  };

  const items = [
    {
      key: '/',
      icon:<FontAwesomeIcon icon={faHouse} className="menu-icon" />,
      label: '',
      show: true,
    },
    {
      key: '/inventory',
      icon: <FontAwesomeIcon icon={faTags} />,
      label: '',
      show: hasProductPermissions(user),
      children: [
        {
          key: '/inventory/manage',
          label: 'Manage Products',
          show: hasSpecificPermission(Helpers.permissionEntities.PRODUCT, Helpers.permissionTypes.READ, user),
          // icon: !enabledInventoryFeatures?.sub_modules?.product?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/inventory/indent',
          label: 'Stock Adjustment',
          show: hasSpecificPermission(Helpers.permissionEntities.INVENTORY_INDENT, Helpers.permissionTypes.READ, user),
          // icon: !enabledInventoryFeatures?.sub_modules?.stock_adjustment?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/inventory/stock-transfer',
          label: 'Stock Transfer',
          show: hasSpecificPermission(Helpers.permissionEntities.STOCK_TRANSFER, Helpers.permissionTypes.READ, user),
          // icon: !enabledInventoryFeatures?.sub_modules?.stock_transfer?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/inventory/delivery-challan',
          label: 'Delivery Challan',
          show: hasSpecificPermission(Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.READ, user),
          // icon: !enabledInventoryFeatures?.sub_modules?.delivery_challan?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        }
      ].filter(child => child.show)
    },
    {
      key: '/logistic',
      icon: <FontAwesomeIcon icon={faWarehouse} />,
      label: '',
      show: hasLogisticsPermissions(user),
      children: [
        {
          key: '/logistic/gate-document',
          label: 'Gate Document',
          show: hasSpecificPermission(Helpers.permissionEntities.GATE_DOCUMENT, Helpers.permissionTypes.READ, user),
          // icon: !enabledLogisticsFeatures?.sub_modules?.gate_document?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        }
      ].filter(child => child.show)
    },
    {
      key: '/purchase',
      icon: <FontAwesomeIcon icon={faCartShopping} />,
      label: '',
      show: hasPurchasePermissions(user),
      children: [
        {
          key: '/purchase/vendors/manage',
          label: 'Vendors',
          show: hasSpecificPermission(Helpers.permissionEntities.VENDORS, Helpers.permissionTypes.READ, user),
          // icon: !enabledPurchaseFeatures?.sub_modules?.vendor?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/purchase/purchase-request',
          label: 'Material Requests',
          show: hasSpecificPermission(Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ, user),
          // icon: !enabledPurchaseFeatures?.sub_modules?.purchase_request?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/purchase/purchase-indent',
          label: 'Purchase Indent',
          show: hasSpecificPermission(Helpers.permissionEntities.PURCHASE_INDENT, Helpers.permissionTypes.READ, user),
        },
        {
          key: '/purchase/rfq',
          label: 'Request for Quotation',
          show: hasSpecificPermission(Helpers.permissionEntities.REQUEST_FOR_QUOTATION, Helpers.permissionTypes.READ, user),
          // icon: !enabledPurchaseFeatures?.addons?.request_for_quotation?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/purchase/purchase-orders',
          label: 'Purchase Orders',
          show: hasSpecificPermission(Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ, user),
          // icon: !enabledPurchaseFeatures?.sub_modules?.purchase_order?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/purchase/goods-receiving',
          label: 'Goods Receiving',
          show: hasSpecificPermission(Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.READ, user),
          // icon: !enabledPurchaseFeatures?.sub_modules?.goods_receiving_note?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/purchase/debit-notes',
          label: 'Debit Notes',
          show: hasSpecificPermission(Helpers.permissionEntities.DEBIT_NOTE, Helpers.permissionTypes.READ, user),
          // icon: !enabledPurchaseFeatures?.sub_modules?.debit_note?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/purchase/vendor-payouts',
          label: 'Outgoing Payments',
          show: hasSpecificPermission(Helpers.permissionEntities.VENDOR_PAYOUT, Helpers.permissionTypes.READ, user),
          // icon: !enabledPurchaseFeatures?.sub_modules?.payment_outgoing?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/purchase/expense',
          label: 'Expenses',
          show: hasSpecificPermission(Helpers.permissionEntities.EXPENSES, Helpers.permissionTypes.READ, user),
          // icon: !enabledPurchaseFeatures?.addons?.expense?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        }
      ].filter(child => child.show)
    },
    {
      key: '/production',
      icon: <FontAwesomeIcon icon={faIndustry} />,
      label: '',
      show: hasProductionPermissions(user),
      children: [
        {
          key: '/production/bom',
          label: 'Bill of Materials',
          show: hasSpecificPermission(Helpers.permissionEntities.BOM, Helpers.permissionTypes.READ, user),
          // icon: !enabledProductionFeatures?.sub_modules?.bill_of_material?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/production/manufacturing-orders',
          label: 'Manufacturing Orders',
          show: hasSpecificPermission(Helpers.permissionEntities.MO, Helpers.permissionTypes.READ, user),
          // icon: !enabledProductionFeatures?.sub_modules?.manufacturing_order?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/production/manual-entry',
          label: 'Manual Entry',
          show: hasSpecificPermission(Helpers.permissionEntities.MO, Helpers.permissionTypes.READ, user),
          // icon: !enabledProductionFeatures?.sub_modules?.manufacturing_order?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/production/job-works',
          label: 'Job Cards',
          show: hasSpecificPermission(Helpers.permissionEntities.FACTORY_SETUP, Helpers.permissionTypes.READ, user),
          // icon: !enabledProductionFeatures?.addons?.factory_setup?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/production/planning/v2',
          label: 'Materials Planning',
          show: hasSpecificPermission(Helpers.permissionEntities.MRP, Helpers.permissionTypes.READ, user),
          // icon: !enabledProductionFeatures?.addons?.material_planing?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/production/configurations',
          label: 'Factory Setup',
          show: hasSpecificPermission(Helpers.permissionEntities.FACTORY_SETUP, Helpers.permissionTypes.READ, user),
          // icon: !enabledProductionFeatures?.addons?.factory_setup?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        }
      ].filter(child => child.show)
    },
    {
      key: '/quality',
      icon: <FontAwesomeIcon icon={faFileShield} />,
      label: '',
      show: hasQualityPermissions(user), // Parent permission check
      children: [
        {
          key: '/quality/quality-control-points',
          label: 'Quality Rules',
          show: hasSpecificPermission(Helpers.permissionEntities.QUALITY_RULES, Helpers.permissionTypes.READ, user),
          // icon: !enabledQualityControlFeatures?.sub_modules?.quality_control_rule?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/quality/quality-checks',
          label: 'Quality Checks',
          show: hasSpecificPermission(Helpers.permissionEntities.QUALITY_CHECKS, Helpers.permissionTypes.READ, user),
          // icon: !enabledQualityControlFeatures?.sub_modules?.quality_check?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        }
      ].filter(child => child.show)
    },
    {
      key: '/sales',
      icon: <FontAwesomeIcon icon={faBagShopping} />,
      label: '',
      show: hasSalesPermissions(user),
      children: [
        {
          key: '/sales/customers',
          label: 'Customers',
          show: hasSpecificPermission(Helpers.permissionEntities.CUSTOMER, Helpers.permissionTypes.READ, user),
          // icon: !enabledSalesFeatures?.sub_modules?.customer?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/sales/estimate',
          label: 'Estimate',
          show: hasSpecificPermission(Helpers.permissionEntities.SALES_ESTIMATE, Helpers.permissionTypes.READ, user),
          // icon: !enabledSalesFeatures?.sub_modules?.sales_estimate?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null,
          // title: `${documentUINames?.estimateUIName || 'Estimate'}s` // For tooltip if needed
        },
        {
          key: '/sales/sales-orders',
          label: 'Sales Order',
          show: hasSpecificPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ, user),
          // icon: !enabledSalesFeatures?.sub_modules?.sales_order?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null,
          title: `${documentUINames?.salesOrderUIName || 'Sales Order'}s` // For tooltip if needed
        },
        {
          key: '/sales/packing-slips',
          label: 'Packing Slip',
          show: hasSpecificPermission(Helpers.permissionEntities.PACKING_SLIP, Helpers.permissionTypes.READ, user),
          // icon: !enabledSalesFeatures?.sub_modules?.packing_slip?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/sales/invoices',
          label: 'Invoices',
          show: hasSpecificPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ, user),
          // icon: !enabledSalesFeatures?.sub_modules?.invoice?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/sales/consumption',
          label: 'Consumption Order',
          show: hasSpecificPermission(Helpers.permissionEntities.CONSUMPTION_ORDER, Helpers.permissionTypes.READ, user),
          // icon: !enabledSalesFeatures?.sub_modules?.consumption_order?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/sales/credit-notes',
          label: 'Credit Note',
          show: hasSpecificPermission(Helpers.permissionEntities.CREDIT_NOTE, Helpers.permissionTypes.READ, user),
          // icon: !enabledSalesFeatures?.sub_modules?.credit_note?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/sales/incoming-payments',
          label: 'Incoming Payments',
          show: hasSpecificPermission(Helpers.permissionEntities.CUSTOMER_PAYMENTS, Helpers.permissionTypes.READ, user),
          // icon: !enabledSalesFeatures?.sub_modules?.payment_incoming?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/sales/ewaybill',
          label: 'e-Way Bills',
          show: hasSpecificPermission(Helpers.permissionEntities.E_WAY_BILL, Helpers.permissionTypes.READ, user),
          // icon: !enabledSalesFeatures?.addons?.e_waybill?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        }
      ].filter(child => child.show)
    },
    {
      key: '/integrations',
      icon: <FontAwesomeIcon icon={faSackDollar} />,
      label: '',
      show: hasAccountingPermissions(user),
      children: [
        {
          key: '/integration/tally',
          label: 'Tally Sync',
          show: hasSpecificPermission(Helpers.permissionEntities.REPORTS, Helpers.permissionTypes.READ, user),
          icon: null // No crown icon for Tally Sync
        },
        {
          key: '/purchase/vendor-payouts',
          label: 'Outgoing Payments',
          show: hasSpecificPermission(Helpers.permissionEntities.VENDOR_PAYOUT, Helpers.permissionTypes.READ, user),
          // icon: !enabledPurchaseFeatures?.sub_modules?.payment_outgoing?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: '/sales/incoming-payments',
          label: 'Incoming Payments',
          show: hasSpecificPermission(Helpers.permissionEntities.CUSTOMER_PAYMENTS, Helpers.permissionTypes.READ, user),
          // icon: !enabledSalesFeatures?.sub_modules?.payment_incoming?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        }
      ].filter(child => child.show)
    },
    {
      key: '/analytics',
      icon: <FontAwesomeIcon icon={faChartPie} />,
      label: '',
      show: hasAnalyticsPermissions(user),
      children: [
        {
          key: '/analytics/newReports/v2',
          label: 'Reports',
          show: hasSpecificPermission(Helpers.permissionEntities.REPORTS, Helpers.permissionTypes.READ, user),
          icon: null // No crown icon for Reports
        },
        {
          key: '/analytics/bulkUpload',
          label: 'Bulk Uploads',
          show: true, // Bulk Upload appears to be always visible
          icon: null
        }
        /* Uncomment if you need Demand Forecasting
        {
          key: '/analytics/forecasting',
          label: '',
          show: true,
          icon: !user?.tenant_info?.global_config?.sub_modules?.demand_forecasting?.is_active ? (
            <H3Image src={Crown} className="user-menu__crown" />
          ) : null
        }
        */
      ].filter(child => child.show)
    },
    {
      key: '/settings',
      icon: <FontAwesomeIcon icon={faGear} />,
      label: '',
      show: hasSettingsPermissions(user),
      children: [
        {
          key: '/settings/team',
          label: 'Manage Team',
          show: (
            Helpers.getPermission(Helpers.permissionEntities.USER_MANAGEMENT, Helpers.permissionTypes.READ, user) || 
            Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP, Helpers.permissionTypes.READ, user)
          ),
          icon: null
        },
        {
          key: '/settings/workflow',
          label: 'Approvals Setup',
          show: Helpers.getPermission(Helpers.permissionEntities.WORKFLOW_SETUP, Helpers.permissionTypes.READ, user),
          // icon: !user?.tenant_info?.global_config?.sub_modules?.approval_workflow?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        },
        {
          key: Helpers.getPermission(Helpers.permissionEntities.USER_MANAGEMENT, Helpers.permissionTypes.READ, user) 
            ? '/settings/business-profile' 
            : '/settings/business-profile?tab=/my-profile',
          label: 'Business Profile',
          show: Helpers.getPermission(Helpers.permissionEntities.USER_MANAGEMENT, Helpers.permissionTypes.READ, user),
          icon: null
        },
        {
          key: '/settings/warehouse-setup',
          label: 'Warehouse Setup',
          show: (
            Helpers.getPermission(Helpers.permissionEntities.USER_MANAGEMENT, Helpers.permissionTypes.READ, user) && 
            enabledWarehouseLocations
          ),
          // icon: !user?.tenant_info?.global_config?.sub_modules?.warehouse_setup?.is_active ? (
          //   <H3Image src={Crown} className="user-menu__crown" />
          // ) : null
        }
      ].filter(child => child.show)
    },
    {
      key: '/admin/business-units',
      icon: <FontAwesomeIcon icon={faUserTie} />,
      label: '',
      // style: { color: '#2D7DF7 !important' },
      onClick: (value) => {
        history.push(value.key);
        setCurrentPage(value.key);
        handleMenuClickClose();
      },
      show: user?.org_id && user?.tenant_info,
    },
  ].filter((item) => item.show);

  const menuItemsBottom = [
    {
      key: 'whatsapp-new',
      icon: (
        <div style={{ position: 'relative' }}>
          <img
            src={WhatsApp}
            alt="WhatsApp"
            style={{ width: '17px', height: '17px', marginLeft: '-1px' }}
          />
          <div className="circles" style={{ pointerEvents: 'none', position: 'absolute', top: -5, right: -5 }}>
            <div className="circle1" />
            <div className="circle2" />
            <div className="circle3" />
          </div>
        </div>
      ),
      label: '',
      onClick: () => window.open('https://www.whatsapp.com/channel/0029Vb1fE9RD8SE36GMYEV0S')
    },
    {
      key: 'whats-new',
      icon: (
        <div style={{ position: 'relative' }}>
          <FontAwesomeIcon icon={faBell} />
          <span id="fb-update-badge" style={{ position: 'absolute', top: -3, right: -3 }} />
        </div>
      ),
      label: '',
      onClick: () => window.open('https://procuzy.notion.site/procuzy-app-change-logs')
    },
    {
      key: 'feedback',
      icon: <FontAwesomeIcon icon={faThumbsUp} />,
      label: '',
      onClick: () => handleMenuClick('https://scribehow.com/page/Procuzy_Usage_Guide___SJJ4sCglSIC0MHRH8zT1pw')
    },
    {
      key: '/contact',
      icon: <FontAwesomeIcon icon={faMessage} />,
      className: 'chat-button',
      label: '',
      onClick: () => window.Intercom('show')
    }
  ];

  // Calculate remaining subscription days
  const subscriptionDaysLeft = useMemo(() => {
    const subscriptionEndDate =
      user?.tenant_info?.global_config?.settings?.next_renewal_date;
    if (!subscriptionEndDate) return 0;

    const providedEndDate = new Date(subscriptionEndDate);
    const currentDate = new Date();
    return Math.floor(
      (providedEndDate - currentDate) / (1000 * 60 * 60 * 24)
    );
  }, [user]);
    const enabledInventoryFeatures = user?.tenant_info?.inventory_config;
    const enabledPurchaseFeatures = user?.tenant_info?.purchase_config;
    const enabledSalesFeatures = user?.tenant_info?.sales_config;
    const enabledProductionFeatures = user?.tenant_info?.production_config;
    const enabledQualityControlFeatures = user?.tenant_info?.quality_control_config;
    const enabledWarehouseLocations = user?.tenant_info?.inventory_config?.settings?.enable_location_based_stock;
    const enabledLogisticsFeatures = user?.tenant_info?.logistics_config;

    const enabledGlobalFeatures = user?.tenant_info?.global_config;
    const subscriptionEndDate = enabledGlobalFeatures?.settings?.next_renewal_date;
    const providedEndDate = new Date(subscriptionEndDate);
    const currentDate = new Date();
    const differenceInMilliseconds = providedEndDate - currentDate;
    const diffInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
    const differenceInDays = Math.floor(diffInDays);

    
    const onOpenChange = (keys) => {
      const key = keys.pop();
      setOpenKeys([key]);
    };
  

  return (
  <Fragment>
    <Layout style={{ minHeight: 'calc(100dvh - 80px)' }}>
      <div className={`user-menu hide__in-mobile ${Helpers.hasExpiryNotification() ? 'user-menu-with-notification' : ''}`}>
        <Sider
          width={80}
          style={{
            position: 'absolute',
            left: 0,
            top: 60,
            bottom: 0,
            zIndex: 15,
            width: '100%',
            maxWidth: '100%',
            minWidth: '100%',
          }}
        >
          {/* {renderMenu()} */}
          <div className="user-menu__wrapper__collapsed">
            <Drawer
              open={showDrawer}
              onClose={() => setShowDrawer(false)}
              width="600px"
              destroyOnClose
              mask={false}
              className="header-right__help-drawer"
            >
              <div className="custom-drawer__header-wrapper">
                <div className="custom-drawer__header" style={{ width: '600px' }}>
                  <H3Text text="Help Centre 👋" className="custom-drawer__title" />
    
                  <div
                    className="custom-drawer__close-icon"
                    onClick={() => setShowDrawer(false)}
                  >
                    <FontAwesomeIcon icon={faCircleXmark} />
                  </div>
                </div>
              </div>
    
              {/* Iframe to show selected content */}
              <iframe
                src={iframeUrl}
                onLoad={() => setIframeLoaded(true)}
              />
              {!iframeLoaded && (
                <div className="header-right__help-drawer-loader">
                  <LoadingOutlined />
                </div>
              )}
            </Drawer>
            <div className="user-menu__logo-menu__item-hover">
              <Menu
                inlineCollapsed={false}
                theme="light"
                mode="inline"
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                >
                <Menu.Item 
                onClick={(value) => {
                  history.push("/");
                  setCurrentPage("/");
                  handleMenuClickClose();
                }} 
                icon={!user?.tenant_info?.global_config?.settings?.white_label_platform  ? (
                  <div className="user-menu__logo">
                    <H3Image
                      src={logo}
                      className="user-menu__logo-image"
                    />
                  </div>
                ) : (
                  <div className="user-menu__logo-wl__collapsed">
                    <div className="user-menu__logo-image-left-wrapper">
                      <H3Image
                        src={org?.organisation?.[0]?.logo}
                        className="user-menu__logo-image-left"
                      />
                    </div>
                  </div>)}>
                </Menu.Item>
              </Menu>
            </div>
            <div className="scrollable-menu__wrapper">
              <Menu
              onClick={(value) => {
                history.push(value.key);
                setCurrentPage(value.key);
                handleMenuClickClose();
              }}
              style={{
                width: 80,
              }}
              mode="vertical"
              items={items}
              expandIcon={null}
              // getPopupContainer={(triggerNode) => triggerNode.parentNode}
              // openKeys={["/purchase"]}
              />
            </div>
            <div
              className="user-menu__bottom"
              style={{
                marginBottom: differenceInDays > -30 && differenceInDays < 15 ? '50px' : '0px',
              }}
            >
              <Menu
                inlineCollapsed={false}
                theme="light"
                mode="vertical"
                style={{
                  padding: '0px !important',
                  marginTop: 'auto',
                }}
                items={menuItemsBottom}
                />
            </div>
          </div>
        </Sider>
      </div>
    </Layout>
  </Fragment>
  );
};
const mapStateToProps = ({ UserReducers, TenantReducers }) => ({
  user: UserReducers.user,
  tenantsConfiguration: TenantReducers.tenantsConfiguration,
  org: UserReducers.org,
});

const mapDispatchToProps = (dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId) => dispatch(TenantActions.getTenants(page, keyword, isVerified, orgId)),
  getTenantsConfiguration: (tenantId) => dispatch(TenantActions.getTenantsConfiguration(tenantId)),

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserMenuHover));